<template>
  <div class="map-background" :style="boxWrapStyleObj">
    <!--市级地图-->
    <div id="city_map" ref="cityMapRef" :style="mapStyleObj"></div>
    <div class="panel-box-wrap district-box" v-show="isShowProvince">
      <div class="close-btn">
        <img class="logo-img" src="../../../assets/images/map/close.png" width="100%" height="100%"
          v-on:click="closeWin" />
      </div>
      <div class="panel-box">
        <div class="panel-left" ref="panelLeftRef">
          <div id="district_map" ref="provinceMapRef" class="left-map"></div>
        </div>
        <div class="district-data-area">
          <div class="popup-item bubble" v-for="(item, index) in districtDataList">
            <div class="popup-item-text" :title="item.value">
              <p class="p-num">
                <count-up class="infor-card-count user-created-count" :id-name="'codes_' + item.name"
                  :end-val="item.value" color="#0EFCFF" countSize="14" :countWeight="countWeight"
                  :isConvert="isConvert">
                </count-up>
              </p>
              <p>{{ item.name }}</p>
            </div>
          </div>
        </div>
        <div class="panel-right">
          <div class="panel-head">
            <div class="head-wrap">
              <div class="right-mian" style="display: flex">
                <input placeholder="请输入学校名称" class="input-cla" v-model="filters.keyWord"
                  v-on:keyup.enter="handleSearch" />
                <div class="search-btn" v-on:click="handleSearch">
                  <div class="search-icon">
                    <img src="../../../assets/images/databoard/detailPage/search.png" width="100%" height="100%" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--按学校统计的学校使用情况列表-->
          <div class="panel-table">
            <div class="header">
              <Col :span="3">
              <span>排序</span>
              </Col>
              <Col :span="10">
              <span>学校名称</span>
              </Col>
              <Col :span="3">
              <span>学段</span>
              </Col>
              <Col :span="4">
              <span>操作次数</span>
              </Col>
              <Col :span="4">
              <span>班级数</span>
              </Col>
            </div>
            <Row class="row-wrap" v-for="(item, index) in schoolUseData" :key="item.id">
              <Col :span="3" class="col-content">
              <div class="sort-item orange-item" :class="(pageParams.page - 1) * pageParams.limit + index++ < 3
    ? 'orange-item'
    : 'blue-item'
    ">
                <span>{{
    (pageParams.page - 1) * pageParams.limit + index++
  }}</span>
              </div>
              </Col>
              <Col :span="10" class="col-content">
              <a :title="item.school_name" href="javascript:void(0);" v-on:click="lookSchoolDashBoard(item.id)"
                style="color: #2d8cf0">{{ item.school_name }}</a>
              </Col>
              <Col :span="3" class="col-content">
              <span>{{ item.phase }}</span>
              </Col>
              <Col :span="4" class="col-content">
              <span>{{ item.ocount }}</span>
              </Col>
              <Col :span="4" class="col-content">
              <span>{{ item.classCount }}</span>
              </Col>
            </Row>
          </div>
          <div class="bottom-page">
            <div class="laypage_main">
              <Page :total="pageParams.total" @on-change="handleCurrentChange" :current="pageParams.page"
                v-if="pageParams.total && pageParams.pageCount > 1"></Page>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--气泡1-->
    <div class="rate-popup rate-popup-one" :title="schoolNum">
      <div class="rate-popup-item">
        <img src="../../../assets/images/nanjindataboard/popup-ratate.png" width="100%" height="100%"
          class="popup-img" />
        <div class="count">
          <span :class="channel == 'sy' ? 'num-sy' : 'num'">
            <count-up class="infor-card-count user-created-count" :id-name="'code_' + '学校总数'" :end-val="schoolNum"
              color="#0EFCFF" countSize="14" :countWeight="countWeight" :isConvert="isConvert">
            </count-up>
          </span>
          <p>学校总数</p>
        </div>
      </div>
    </div>
    <!--气泡2-->
    <div class="rate-popup rate-popup-two gu-zhou-popup-two" :title="classNum">
      <div class="rate-popup-item">
        <img src="../../../assets/images/nanjindataboard/popup-ratate.png" width="100%" height="100%"
          class="popup-img" />
        <div class="count">
          <span :class="channel == 'sy' ? 'num-sy' : 'num'">
            <count-up class="infor-card-count user-created-count" :id-name="'code_' + '班级总数'" :end-val="classNum"
              color="#0EFCFF" countSize="14" :countWeight="countWeight" :isConvert="isConvert">
            </count-up>
          </span>
          <p>班级总数</p>
        </div>
      </div>
    </div>
    <!--气泡3-->
    <div class="rate-popup rate-popup-three" :title="studentNum">
      <div class="rate-popup-item">
        <img src="../../../assets/images/nanjindataboard/popup-ratate.png" width="100%" height="100%"
          class="popup-img" />
        <div class="count">
          <span :class="channel == 'sy' ? 'num-sy' : 'num'">
            <count-up class="infor-card-count user-created-count" :id-name="'code_' + '学生总数'" :end-val="studentNum"
              color="#0EFCFF" countSize="14" :countWeight="countWeight" :isConvert="isConvert">
            </count-up>
          </span>
          <p>学生总数</p>
        </div>
      </div>
    </div>
    <!--气泡4-->
    <div class="rate-popup rate-popup-four gu-zhou-popup-four" :title="teacherNum">
      <div class="rate-popup-item">
        <img src="../../../assets/images/nanjindataboard/popup-ratate.png" width="100%" height="100%"
          class="popup-img" />
        <div class="count">
          <span :class="channel == 'sy' ? 'num-sy' : 'num'">
            <count-up class="infor-card-count user-created-count" :id-name="'code_' + '教师总数'" :end-val="teacherNum"
              color="#0EFCFF" countSize="14" :countWeight="countWeight" :isConvert="isConvert">
            </count-up>
          </span>
          <p>教师总数</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDistrictSchoolList,
  getRegionSchoolInfomation,
  getNextRegionSchoolInfomation,
  queryBaseRegionCoordinateByRegionCode,
} from "../../../service/api";
import CountUp from "../../../components/countUp.vue";
import axios from "axios";
export default {
  name: "city-map",
  components: {
    CountUp,
  },
  props: ["areaCode", "areaName", "areaParams", "type", 'regionId'],
  data() {
    return {
      channel: process.env.VUE_APP_CHANNEL,
      map: null, //地图
      //地图宽高
      mapStyleObj: {
        width: "100%",
        height: "100%",
      },
      //页面整体样式对象
      boxWrapStyleObj: {
        height: "0px",
      },
      countWeight: 700,
      //是否转换数字
      isConvert: process.env.VUE_APP_CHANNEL == 'sy' ? 2 : 1,
      //显示二级区统计图
      isShowProvince: false,
      geoCoordMap: {},
      provinceList: [
        {
          pinyin: "shanghai",
          name: "上海",
          code: "310000",
        },
        {
          pinyin: "hebei",
          name: "河北",
          code: "130000",
        },
        {
          pinyin: "shanxi",
          name: "山西",
          code: "140000",
        },
        {
          pinyin: "neimenggu",
          name: "内蒙古",
          code: "150000",
        },
        {
          pinyin: "liaoning",
          name: "辽宁",
          code: "210000",
        },
        {
          pinyin: "jilin",
          name: "吉林",
          code: "220000",
        },
        {
          pinyin: "heilongjiang",
          name: "黑龙江",
          code: "230000",
        },
        {
          pinyin: "jiangsu",
          name: "江苏",
          code: "320000",
        },
        {
          pinyin: "zhejiang",
          name: "浙江",
          code: "330000",
        },
        {
          pinyin: "anhui",
          name: "安徽",
          code: "340000",
        },
        {
          pinyin: "fujian",
          name: "福建",
          code: "350000",
        },
        {
          pinyin: "jiangxi",
          name: "江西",
          code: "360000",
        },
        {
          pinyin: "shandong",
          name: "山东",
          code: "370000",
        },
        {
          pinyin: "henan",
          name: "河南",
          code: "410000",
        },
        {
          pinyin: "hubei",
          name: "湖北",
          code: "420000",
        },
        {
          pinyin: "hunan",
          name: "湖南",
          code: "430000",
        },
        {
          pinyin: "guangdong",
          name: "广东",
          code: "440000",
        },
        {
          pinyin: "guangxi",
          name: "广西",
          code: "450000",
        },
        {
          pinyin: "hainan",
          name: "海南",
          code: "460000",
        },
        {
          pinyin: "sichuan",
          name: "四川",
          code: "510000",
        },
        {
          pinyin: "guizhou",
          name: "贵州",
          code: "520000",
        },
        {
          pinyin: "yunnan",
          name: "云南",
          code: "530000",
        },
        {
          pinyin: "xizang",
          name: "西藏",
          code: "540000",
        },
        {
          pinyin: "shanxi1",
          name: "陕西",
          code: "610000",
        },
        {
          pinyin: "qinghai",
          name: "青海",
          code: "630000",
        },
        {
          pinyin: "ningxia",
          name: "宁夏",
          code: "640000",
        },
        {
          pinyin: "gansu",
          name: "甘肃",
          code: "620000",
        },
        {
          pinyin: "xinjiang",
          name: "新疆",
          code: "650000",
        },
        {
          pinyin: "beijing",
          name: "北京",
          code: "110000",
        },
        {
          pinyin: "tianjin",
          name: "天津",
          code: "120000",
        },
        {
          pinyin: "chongqing",
          name: "重庆",
          code: "500000",
        },
        {
          pinyin: "xianggang",
          name: "香港",
          code: "810000",
        },
        {
          pinyin: "aomen",
          name: "澳门",
          code: "820000",
        },
        {
          pinyin: "taiwan",
          name: "台湾",
          code: "710000",
        },
      ],
      data: [],
      //区域数据集合
      districtDataList: [
        {
          name: "学校总数",
          value: 0,
        },
        {
          name: "班级总数",
          value: 0,
        },
        {
          name: "教师总数",
          value: 0,
        },
        {
          name: "学生总数",
          value: 0,
        },
      ],
      teacherNum: 0,
      classNum: 0,
      studentNum: 0,
      schoolNum: 0,
      mapData: [],
      maxNum: 0,
      provinceMap: null, //省级地图
      provinceMapData: [],
      currentCode: "", //省code
      currentCityCode: "", //市code
      schoolUseData: [], //学校使用数据
      filters: {
        keyWord: "",
      },
      pageParams: {
        page: 1,
        limit: 10,
        total: 0,
        pageCount: 0,
      },
      cityData: {},
      districtData: {},
    };
  },
  methods: {
    /**
     * 翻页
     */
    handleCurrentChange(val) {
      this.pageParams.page = val;
      this.queryDistrictSchoolList(this.currentCode);
    },
    /**
     * 点击查看学校数据展板
     */
    lookSchoolDashBoard(schoolId) {
      let routeData = this.$router.resolve({
        name:
          schoolId == "75047a8a0990480f8abf3a39bc25f1ab"
            ? "cloudschooldataboard"
            : "schooldataboard",
        params: {
          schoolId: schoolId,
        },
        query: {
          origin: "chart",
          tokenId: this.$store.getters.token,
          userId: this.$store.getters.userId,
        },
      });
      window.open(routeData.href, "_blank");
    },
    /**
     * 通过区域code获取该区域的学校数，班级数，学生数和教师数
     */
    async getRegionSchoolInformation() {
      let _this = this;
      let params = {
        provinceCode: _this.areaParams.provinceCode,
        cityCode: _this.areaParams.cityCode,
        districtCode: _this.areaParams.districtCode,
        regionId: _this.regionId
      };
      let res = await getRegionSchoolInfomation(params);
      _this.schoolNum = res[0].schoolNum;
      _this.classNum = res[0].classNum;
      _this.studentNum = res[0].stuNum;
      _this.teacherNum = res[0].teaNum;
    },
    /**
     * 通过区域code获取下级区域数据
     */
    async getNextRegionSchoolInformation() {
      let _this = this;
      let params = {
        provinceCode: _this.areaParams.provinceCode,
        cityCode: _this.areaParams.cityCode,
        districtCode: _this.areaParams.districtCode,
        regionId: _this.regionId
      };
      let res = await getNextRegionSchoolInfomation(params);
      _this.data = _this.getAreaMapData(res);
      if (_this.type == "province") {
        let province = "";
        let provinceName = "";
        for (let i = 0; i < _this.provinceList.length; i++) {
          if (this.areaCode == _this.provinceList[i].code) {
            province = _this.provinceList[i].pinyin;
            provinceName = _this.provinceList[i].name;
            break;
          }
        }
        _this.initProvinceMap(province, provinceName);
      } else if (_this.type == "city") {
        //根据区域编码获取地理位置数据
        let data = await _this.getBaseRegionCoordinateByRegionCode(
          _this.areaParams.cityCode
        );
        _this.initCityMap(data);
      } else {
        //根据区域编码获取地理位置数据
        let data = await _this.getBaseRegionCoordinateByRegionCode(
          _this.areaParams.districtCode
        );
        _this.initDistrictsMap(data);
      }
    },
    /**
     * 根据区域编码获取地理位置数据
     */
    async getBaseRegionCoordinateByRegionCode(data) {
      let _this = this;
      let params = {
        regionCode: data,
      };
      let res = await queryBaseRegionCoordinateByRegionCode(params);
      return JSON.parse(res.coordinateCode);
    },
    /**
     * 初始化地图
     */
    initProvinceMap(provice, provinceName) {
      let _this = this;
      let areaData = require("echarts/map/json/province/" + provice + ".json");
      _this.$echarts.registerMap(this.areaName, areaData); //注册

      //获取二级区域的经纬度
      // let mapFeatures = _this.$echarts.getMap(provinceName).geoJson.features;
      let mapFeatures = _this.$echarts.getMap(_this.areaName).geoJson.features;
      if (mapFeatures)
        mapFeatures.forEach(function (v) {
          // 地区名称
          var name = v.properties.name;
          // 地区经纬度
          _this.geoCoordMap[name] = v.properties.cp;
        });

      _this.initMap(provinceName);
    },
    /**
     * 获取地图数据
     */
    getAreaMapData(list) {
      let data = [];
      for (let i = 0; i < list.length; i++) {
        let areaObj = {};
        areaObj.name =
          this.type == "province" ? list[i].cityName : list[i].districtName;
        areaObj.code =
          this.type == "province" ? list[i].cityCode : list[i].districtCode;
        areaObj.value = list[i].schoolNum;
        areaObj.districtDataList = [
          {
            name: "学校总数",
            value: list[i].schoolNum,
          },
          {
            name: "班级总数",
            value: list[i].classNum,
          },
          {
            name: "教师总数",
            value: list[i].teaNum,
          },
          {
            name: "学生总数",
            value: list[i].stuNum,
          },
        ];
        data.push(areaObj);
      }
      return data;
    },
    /**
     * 初始化城市地图
     */
    initCityMap(data) {
      let _this = this;
      _this.cityData = data;
      // var cityData = require("../../../../static/json/南京市/南京市.json");
      this.$echarts.registerMap(_this.areaName, _this.cityData); //注册
      //获取市级下区域的经纬度
      let mapFeatures = this.$echarts.getMap(_this.areaName).geoJson.features;
      mapFeatures.forEach(function (v) {
        // 地区名称
        let name = v.properties.name;
        // 地区经纬度
        _this.geoCoordMap[name] = v.properties.centroid;
      });
      _this.initMap(_this.areaName);
    },
    /**
     * 各地区经纬度，数值data
     */
    convertData(data) {
      let _this = this;
      var res = [];
      for (var i = 0; i < data.length; i++) {
        var geoCoord = _this.geoCoordMap[data[i].name];
        if (geoCoord) {
          res.push({
            name: data[i].name,
            code: data[i].code,
            value: geoCoord.concat(data[i].value),
          });
        }
      }
      return res;
    },
    /**
     * 初始化区域地图
     */
    initDistrictsMap(data) {
      let _this = this;
      _this.districtData = data;
      // _this.districtData = require("../../../../static/json/西岗区.json");
      this.$echarts.registerMap(_this.areaName, _this.districtData); //注册
      //获取市级下区域的经纬度
      let mapFeatures = this.$echarts.getMap(_this.areaName).geoJson.features;
      mapFeatures.forEach(function (v) {
        // 地区名称
        let name = v.properties.name;
        // 地区经纬度
        _this.geoCoordMap[name] = v.properties.centroid;
      });
      _this.initMap(_this.areaName);
    },
    /**
     * 渲染地图
     */
    initMap(provinceName) {
      let _this = this;
      //配置样式
      var optionMap = {
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            if (params.seriesType === "map") {
              if (params.name == "") {
                return;
              }
              if (!isNaN(params.value)) {
                return params.name + " : " + params.value;
              }
            } else if (params.seriesType === "scatter") {
              return params.name + " : " + params.value[2];
            } else if (params.seriesType === "effectScatter") {
              return params.name + " : " + params.value[2];
            } else {
              return "暂无数据";
            }
          },
        },
        geo: {
          map: provinceName,
          zoom: 1.1,
          roam: false,
          top: "5%",
          label: {
            normal: {
              show: false,
              textStyle: {
                color: "#fff",
              },
            },
            emphasis: {
              show: false,
              color: "#fff",
            },
          },
          itemStyle: {
            normal: {
              areaColor: "#24CFF4",
              borderColor: "#53D9FF",
              borderWidth: 1.3,
              shadowBlur: 15,
              shadowColor: "rgb(58,115,192)",
              shadowOffsetX: 7,
              shadowOffsetY: 6,
            },
            emphasis: {
              areaColor: "#8dd7fc",
              borderWidth: 1.6,
              shadowBlur: 25,
            },
          },
        },
        // 视觉映射组件
        visualMap: {
          show: false,
          min: 0,
          max: _this.findMaxVal(_this.data),
          left: "25%",
          bottom: "12%",
          text: ["高", "低"], // 文本，默认为数值文本
          textStyle: {
            color: "#fff",
          },
          calculable: true,
          seriesIndex: [1],
          inRange: {
            color: ["#24CFF4", "#2E98CA", "#1E62AC"],
          },
        },
        series: [
          {
            type: "effectScatter",
            coordinateSystem: "geo",
            geoIndex: 0,
            data: _this.convertData(_this.data),
            symbolSize: 12,
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke",
            },
            animation: true,
            label: {
              normal: {
                formatter: "{b}",
                position: "top",
                show: true,
                textStyle: {
                  color: "#fff",
                },
              },
            },
            itemStyle: {
              normal: {
                color: "#f4e925",
                shadowBlur: 10,
                shadowColor: "#333",
              },
            },
            zlevel: 1,
          },
          {
            name: "categoryChina",
            type: "map",
            geoIndex: 0,
            data: _this.data,
          },
        ],
      };
      let winHeight = window.innerHeight;
      if (winHeight < 900) {
        winHeight = 938;
      }
      let boxWrapHeight = winHeight - 128 - 10;
      let contentHeight = boxWrapHeight - 20;
      this.boxWrapStyleObj.height = boxWrapHeight + "px";
      _this.$refs.cityMapRef.style.height = contentHeight + "px";
      let dom = document.getElementById("city_map");
      //得到echarts的实例对象
      _this.map = _this.$echarts.init(dom);
      _this.map.setOption(optionMap);
      //点击弹出区地图
      _this.map.on("click", function (params) {
        _this.pageParams.total = 0;
        _this.pageParams.page = 1;
        _this.pageParams.pageCount = 0;
        for (let i = 0; i < _this.data.length; i++) {
          if (_this.data[i].name == params.name) {
            //动态加载区地图
            let data = [];
            data.push(_this.data[i]);
            _this.initDistrictMap(data);
            _this.currentCode = params.data.code;
            _this.districtDataList = _this.data[i].districtDataList;
            _this.queryDistrictSchoolList(params.data.code);
          }
        }
      });
    },
    /**
     * 动态加载区地图
     */
    async initDistrictMap(data) {
      let _this = this;
      var districtData = {};
      if (_this.type == "province") {
        districtData = await _this.getBaseRegionCoordinateByRegionCode(
          data[0].code
        );
      } else if (_this.type == "city") {
        districtData = _this.getCurrentDistrictData(data);
      } else {
        districtData = _this.districtData;
      }
      this.$echarts.registerMap(data[0].name, districtData); //注册
      var mapFeatures = this.$echarts.getMap(data[0].name).geoJson.features;
      mapFeatures.forEach(function (v) {
        // 地区名称
        var name = v.properties.name;
        // 地区经纬度
        _this.geoCoordMap[name] = v.properties.center;
      });
      //配置样式
      var optionMap = {
        title: {
          text: data[0].name,
          left: "20",
          textStyle: {
            color: "#0EFCFF",
          },
        },
        tooltip: {
          trigger: "item",
          formatter: function (params) { },
        },
        geo: {
          map: data[0].name,
          roam: false,
          top: "30%",
          aspectScale: "1.2",
          label: {
            normal: {
              show: false,
              textStyle: {
                color: "#fff",
              },
            },
            emphasis: {
              show: false,
              color: "#fff",
            },
          },
          itemStyle: {
            normal: {
              areaColor: "#1e62ac",
              borderColor: "#53D9FF",
              borderWidth: 1.3,
              shadowBlur: 15,
              shadowColor: "rgb(58,115,192)",
              shadowOffsetX: 7,
              shadowOffsetY: 6,
            },
            emphasis: {
              areaColor: "#8dd7fc",
              borderWidth: 1.6,
              shadowBlur: 25,
            },
          },
        },
        series: [
          {
            type: "effectScatter",
            coordinateSystem: "geo",
            geoIndex: 0,
            data: _this.convertData(data),
            symbolSize: 12,
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke",
            },
            animation: true,
            label: {
              normal: {
                formatter: "{b}",
                position: "top",
                show: true,
                textStyle: {
                  color: "#fff",
                },
              },
            },
            itemStyle: {
              normal: {
                color: "#f4e925",
                shadowBlur: 10,
                shadowColor: "#333",
              },
            },
            zlevel: 1,
          },
          {
            name: "categoryChina",
            type: "map",
            geoIndex: 0,
            data: data,
          },
        ],
      };
      var dom = document.getElementById("district_map");
      //得到echarts的实例对象
      var myChart = _this.$echarts.init(dom);
      myChart.setOption(optionMap);
      _this.$nextTick(() => {
        // 打开弹窗
        _this.isShowProvince = true;
      });
    },
    /**
     * 获取特定的区域数据
     */
    getCurrentDistrictData(data) {
      let obj = {
        type: "FeatureCollection",
        features: [],
      };
      for (let i = 0; i < this.cityData.features.length; i++) {
        if (this.cityData.features[i].properties.adcode == data[0].code) {
          obj.features.push(this.cityData.features[i]);
          return obj;
        }
      }
    },
    /**
     * 获取最大数值
     */
    findMaxVal(data) {
      let curMaxNum = 0;
      for (var i = 0; i < data.length; i++) {
        if (curMaxNum < data[i].value) {
          curMaxNum = data[i].value;
        }
      }
      return curMaxNum;
    },
    /**
     * 关闭弹窗
     */
    closeWin() {
      this.filters.keyWord = "";
      this.pageParams.total = 0;
      this.pageParams.page = 1;
      this.pageParams.pageCount = 0;
      this.provinceMapData = [];
      this.currentProvinceName = "";
      this.currentProvinceCode = "";
      this.currentCityCode = "";
      this.isShowProvince = false;
    },
    /**
     * 查询
     */
    handleSearch() {
      this.pageParams.total = 0;
      this.pageParams.page = 1;
      this.pageParams.pageCount = 0;
      this.queryDistrictSchoolList(this.currentCode);
    },
    /**
     * 获取区域下的学校列表
     */
    queryDistrictSchoolList(code) {
      let _this = this;
      let params = {};
      if (_this.type == "province") {
        params = {
          province: _this.areaParams.provinceCode,
          city: code,
          districtId: "",
          page: _this.pageParams.page,
          limit: _this.pageParams.limit,
          keyWord: _this.filters.keyWord,
          regionId: _this.regionId
        };
      } else {
        params = {
          province: _this.areaParams.provinceCode,
          city: _this.areaParams.cityCode,
          districtId: code,
          page: _this.pageParams.page,
          limit: _this.pageParams.limit,
          keyWord: _this.filters.keyWord,
          regionId: _this.regionId
        };
      }
      getDistrictSchoolList(params)
        .then(function (res) {
          let data = res.classCountList;
          _this.handleData(data);
          _this.pageParams.total = res.gradeTotal;
          _this.pageParams.pageCount = Math.ceil(
            res.gradeTotal / _this.pageParams.limit
          );
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
    /**
     * 处理数据
     */
    handleData(data) {
      for (let i = 0; i < data.length; i++) {
        data[i].classCount = data[i].classCount + 2;
      }
      this.schoolUseData = data;
    },
  },
  mounted() {
    let _this = this;
    //通过区域code获取区域数据
    _this.getRegionSchoolInformation();
    //通过区域code获取下级区域数据
    _this.getNextRegionSchoolInformation();
    // 更新地图
    window.addEventListener("resize", function () {
      let winHeight = window.innerHeight;
      if (winHeight < 900) {
        winHeight = 938;
      }
      let boxWrapHeight = winHeight - 128 - 10;
      let contentHeight = boxWrapHeight - 20;
      _this.boxWrapStyleObj.height = boxWrapHeight + "px";
      _this.$refs.cityMapRef.style.height = contentHeight + "px";
      _this.map.resize();
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../../../style/databoard";
@import "../../../style/map";

.map-container {
  position: relative;
  box-sizing: border-box;
  padding: 0 22px 0 22px;
}

.panel-box {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
  background-image: url("../../../assets/images/map/box-bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.map-background {
  background-image: url("../../../assets/images/nanjindataboard/bg1.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
}

.bubble {
  background-image: url("../../../assets/images/nanjindataboard/popup.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.popup-img {
  animation: rota 10s infinite linear;
  -webkit-animation: rota 10s infinite linear;
  -moz-animation: rota 10s infinite linear;
}
</style>